/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Monday, August 8th 2022, 3:22:13 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */
/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Wednesday, August 3rd 2022, 4:50:21 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import React from "react";
import { useGlobalScope } from "core/providers";
import { getDefaultDatasetReference } from "lib/factories";
import { DatasetReference, DatasetReferenceValidationSchema } from "lib/schemas";
import { APISERVICEPATHS, useAPIForm } from "lib/api";

const datasetReferencesAPIServicePath = APISERVICEPATHS.datasetReferences;

interface UseDatasetReferenceAPIFormArgs {
  datasetReferenceId?: DatasetReference["id"];
}

const useDatasetReferenceAPIForm = ({ datasetReferenceId = null }: UseDatasetReferenceAPIFormArgs) => {
  const {
    globalState: { selectedOrganization },
  } = useGlobalScope();

  const [datasetReference, setDatasetReference] = React.useState<DatasetReference>(
    getDefaultDatasetReference(selectedOrganization.id)
  );

  const useAPIFormReturn = useAPIForm<DatasetReference>({
    apiFormDefaultValues: datasetReference,
    apiFormDataValidationSchema: DatasetReferenceValidationSchema,
    setAPIFormResponse: setDatasetReference,
    apiInitialFetchId: datasetReferenceId,
    apiServicePath: datasetReferencesAPIServicePath,
    primaryKey: "id",
    successNotificationMessage: `Successfully updated the ${datasetReference.name} dataset reference`,
    formResetDependencyArray: [datasetReference?.id],
  });

  return { useAPIFormReturn };
};

export const useDatasetReferenceAPI = () => ({
  useDatasetReferenceAPIForm,
});
